// extracted by mini-css-extract-plugin
export default {"mfcontainer":"Microfrontend--mfcontainer--Sw1H-"};